import PropTypes from 'prop-types';

const NoiseIcon = ({ size, fill, ...other }) => (
  <div style={{ fontSize: size }} {...other}>
    <svg width="1em" height="1em" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m8.624 20.222 4.084-4.155c.48-.49 1.442-.734 2.162-.734.721.245 1.442.734 1.682 1.467l4.805 11.733 7.448-19.066C29.045 8.489 30.006 8 30.727 8h.24c.721 0 1.682.489 2.163 1.222l6.486 11h8.113C45.915 8.762 35.982 0 24 0S2.085 8.762.27 20.222h8.354zM24 48c12.896 0 23.418-10.15 24-22.888h-9.585c-.96 0-1.682-.49-2.162-1.223l-4.805-8.067-7.688 20.045c-.24.733-1.202 1.466-2.163 1.466-.96 0-1.922-.489-2.162-1.466l-5.766-13.69-2.402 2.445c-.48.245-.961.49-1.682.49H0C.582 37.85 11.104 48 24 48z"
        fill={fill}
        fillRule="evenodd"
      />
    </svg>
  </div>
);

NoiseIcon.propTypes = {
  size: PropTypes.string,
  fill: PropTypes.string,
};

NoiseIcon.defaultProps = {
  size: 'inherit',
  fill: 'currentColor',
};

export default NoiseIcon;
